import { useEffect, useState } from "react";
import { toast } from "sonner";
import { QrCode, Upload, Loader2 } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { errMsg } from "@/lib/api";
import { resizeImage } from "@/lib/branding";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const inp = "w-full h-10 px-3 rounded-lg border text-sm outline-none focus:ring-2 focus:ring-[#B91C1C]";

export function QrPaymentCard({ req }) {
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { req("get", "/staff/payment-qr").then(setCfg).catch((e) => toast.error(errMsg(e))); }, [req]);
  if (!cfg) return null;
  const set = (k, v) => setCfg((p) => ({ ...p, [k]: v }));

  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const data = await resizeImage(file, 900, "image/png");
      set("image", (await req("post", "/staff/media", { data })).url);
      toast.success("Gambar QR dimuat naik — tekan Simpan");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const save = async () => {
    setBusy(true);
    try { setCfg(await req("put", "/staff/payment-qr", cfg)); toast.success("Tetapan QR disimpan"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <section className="bg-white rounded-2xl border p-6 space-y-4" data-testid="qr-payment-card">
      <h3 className="font-display font-bold flex items-center gap-2"><QrCode className="w-5 h-5 text-red-700" />Bayar Terus (QR)</h3>
      <label className="flex items-center justify-between gap-4">
        <span className="text-sm">Benarkan pelanggan bayar terus guna QR<span className="block text-xs text-slate-500">Pelanggan scan QR, bayar, dan muat naik bukti bayaran. Bukti dihantar bersama mesej WhatsApp pesanan.</span></span>
        <Switch checked={!!cfg.enabled} onCheckedChange={(v) => set("enabled", v)} data-testid="qr-enabled" />
      </label>
      <div className="flex items-center gap-4">
        <div className="w-32 h-32 rounded-xl border bg-slate-50 grid place-items-center overflow-hidden shrink-0">
          {cfg.image ? <img src={cfg.image.startsWith("/") ? `${BACKEND}${cfg.image}` : cfg.image} alt="QR" className="w-full h-full object-contain" data-testid="qr-preview" /> : <QrCode className="w-10 h-10 text-slate-300" />}
        </div>
        <div className="flex-1 space-y-2">
          <label className={`inline-flex px-4 h-10 rounded-lg bg-[#B91C1C] text-white text-sm font-semibold items-center gap-2 cursor-pointer ${busy ? "opacity-60 pointer-events-none" : ""}`}>
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}{cfg.image ? "Tukar QR" : "Muat Naik QR"}
            <input type="file" accept="image/*" className="hidden" onChange={upload} data-testid="qr-upload" />
          </label>
          <input value={cfg.label} onChange={(e) => set("label", e.target.value)} placeholder="Label (cth: DuitNow QR / Maybank QR)" data-testid="qr-label" className={inp} />
        </div>
      </div>
      <button onClick={save} disabled={busy} data-testid="qr-save" className="px-5 h-10 rounded-lg bg-[#B91C1C] text-white text-sm font-semibold active:scale-95 transition-transform disabled:opacity-60">Simpan Tetapan QR</button>
    </section>
  );
}
